<template>
  <div class="fan_page">
      <topSearch></topSearch>
      <div class="lsit_wrapper">
        <div class="list" v-for="item in dataLists" :key="item.id">
          <div class="list_l">
            <!--img :src="item.avatarUrl!=null&&item.avatarUrl!=''?item.avatarUrl:globalUrl + 'images/basicprofile.png'" class="user_pic" /-->
            <img :src="globalUrl + 'images/basicprofile.png'" class="user_pic"/>
          </div>
          <div class="list_r">
            <div class="list_top">
              <!-- <p class="title">{{item.nikeName!=null&&item.nikeName!=''?item.nikeName:'券粉'}}</p> -->
              <p class="title">券粉</p>
              <p class="money">原价 {{item.price}} 元， 用券后 {{item.money}} 元</p>
              <p class="des">{{item.goodsName}}</p>
              <img :src="item.goodsPic" class="list_pic" />
            </div>
            <div class="list_btm">
              <span class="time">券有效期至{{item.couponEndTime}}</span>
              <span class="mark">已有{{item.sells}}人领券购买</span>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import { Indicator } from 'mint-ui' //提示搜索优惠券
import {getDateDiff,config} from  '../../common/js/common.js'
import TopSearch from "@/components/common/topSearch"
export default {
  name:"couponFan",
  components:{
    "topSearch":TopSearch,
  },
  data(){
    return{
      dataLists:[],
      page:1,
      pageSize:10,
      globalUrl:config.gobalUrl
    }
  },
  methods:{
    /*axios调用数据*/
     login () {
       this.url = "api/getUserBuyInfo.php?page="+this.page+"&pageSize="+this.pageSize
       this.$ajax.autoService
           .login(this.url)
           .then((res) => {
             console.log(res)
             this.dataLists = this.dataLists.concat(res.data.map(function(item){
                item.buyTime = getDateDiff(new Date(item.buyTime.replace(/-/g, '/')));
               return item
             }))
             //this.loading = false
             this.$nextTick(() => {
               this.REQUIRE = true;
               this.loading = false;
               Indicator.close()
               if(res.data==0){//如果数据已无，则不滑动数据
                 this.REQUIRE = false
               }
             });
             console.log(this.dataLists)
           }, (res) => {
               console.log("error")
               this.REQUIRE = true;
           })
      },
      /*axios向下加载*/
      scrollBottom() {
       // 滚动到页面底部时，请求前一天的文章内容
       var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
       //
       //  if (scrollTop > this.offsetTop) {
       //     this.navBarFixed = true
       //   } else {
       //     this.navBarFixed = false
       //   }

       if (((window.screen.height + scrollTop) > (document.body.clientHeight)-10)&& this.REQUIRE) {
        Indicator.open('正在加载优惠券');
         // 请求的数据未加载完成时，滚动到底部不再请求前一天的数据
         this.REQUIRE = false;
         this.loading = true;
         this.tips = '努力加载中...';
         this.page+=1
         this.login(this.url)

   }
   }
 },
 created (){
  this.login()
 },
 mounted(){
    window.onscroll = this.scrollBottom
 },
 beforeDestroy(){
   Indicator.close()
   window.onscroll = ""
 }
}
</script>

<style lang="stylus">
  .list
    display:flex
    padding:25px 30px
    margin-bottom:20px
    background:#fff
    .list_l
      flex:0 0 70px
      .user_pic
        width:60px
        height:60px
        border-radius:30px
    .list_r
      flex:1
      .list_top
        border-bottom:1px solid #f0f0f0
        padding-bottom:10px
        /*px*/
        .title
          font-size:28px
          color:#999
        .money
          font-size:30px
          color:#333
        .des
          font-size:28px
          color:#666
        .list_pic
          max-width:100%
      .list_btm
        display:flex
        justify-content:space-between
        padding-top:15px
        line-height:36px
        font-size:24px
        color:#999
        .mark
          color:#fa6700
          font-weight:bold



</style>



// WEBPACK FOOTER //
// src/components/userCenter/couponFan.vue